var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1238 3.59303L1.81503 20.518C1.44848 21.1844 1.93064 21.9999 2.69124 21.9999H21.3087C22.0693 21.9999 22.5515 21.1844 22.1849 20.518L12.8762 3.59303C12.4963 2.90226 11.5037 2.90226 11.1238 3.59303ZM11 9.99991C11 9.44763 11.4477 8.99991 12 8.99991C12.5523 8.99991 13 9.44763 13 9.99991V15.9999C13 16.5522 12.5523 16.9999 12 16.9999C11.4477 16.9999 11 16.5522 11 15.9999V9.99991ZM12 17.9999C11.4477 17.9999 11 18.4476 11 18.9999C11 19.5522 11.4477 19.9999 12 19.9999C12.5523 19.9999 13 19.5522 13 18.9999C13 18.4476 12.5523 17.9999 12 17.9999Z","fill":"white"}));
}

Error.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Error;

Error.default = Error;
